"use client";

import { useLocale, useTranslations } from "next-intl";
import { useTransition } from "react";
import type { SelectChangeEvent } from "@/components/controls/base-controls";
import {
	Box,
	FormControl,
	MenuItem,
	Select,
} from "@/components/controls/base-controls";
import { usePathname, useRouter } from "@/i18n/navigation";

type LocaleSelectProps = {
	fontColor?: string;
};

export default function LocaleSelect({ fontColor }: LocaleSelectProps) {
	const router = useRouter();
	const pathname = usePathname();
	const locale = useLocale();
	const t = useTranslations();

	const [isPending, startTransition] = useTransition();

	const handleLanguageChange = (event: SelectChangeEvent<typeof locale>) => {
		const nextLocale = event.target.value;
		startTransition(() => {
			router.replace(pathname, { locale: nextLocale, scroll: false });
		});
	};

	return (
		<Box sx={{ width: {xs: "auto", md: 120 }}}>
			<FormControl fullWidth>
				<Select
					labelId="language-select-label"
					id="language-select"
					value={locale}
					label={t('locale.language')}
					onChange={handleLanguageChange}
					MenuProps={{ slotProps: { list: { disablePadding: true } } }}
					sx={{
						opacity: isPending ? 0.6 : 1,
						cursor: isPending ? 'not-allowed' : 'pointer',
						fontSize: {xs: ".6em", md: ".875em" },
						mt: {xs: "3px", md: "2px" },
						...(fontColor && { color: fontColor }),
						"& .MuiSvgIcon-root": fontColor ? { color: fontColor } : {},
						"& .MuiOutlinedInput-notchedOutline": { border: "none" },
						"& .MuiSelect-select": { paddingTop: 0, paddingBottom: 0 },
						"& .MuiInputBase-root": { paddingTop: 0, paddingBottom: 0 },
						"& .MuiOutlinedInput-root": { paddingTop: 0, paddingBottom: 0 }
					}}
				>
					<MenuItem value="en" sx={{fontSize: {xs: ".6em", md: ".875em" }, minHeight: {xs: "30px", md: "38px" }}}>English</MenuItem>
					{/* <MenuItem value="es" sx={{fontSize: {xs: ".75em", md: ".875em" }, minHeight: {xs: "34px", md: "38px" }}}>Español</MenuItem>
					<MenuItem value="fr" sx={{fontSize: {xs: ".75em", md: ".875em" }, minHeight: {xs: "34px", md: "38px" }}}>Français</MenuItem> */}
				</Select>
			</FormControl>
		</Box>
	);
}
